import {ChangeDetectionStrategy, Component} from '@angular/core';
import {RolesMainComponent} from '../../roles/roles-main/roles-main.component';

@Component({
  selector: 'people-roles-wrapper',
  standalone: true,
  imports: [RolesMainComponent],
  templateUrl: './people-roles-wrapper.component.html',
  styleUrl: './people-roles-wrapper.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PeopleRolesWrapperComponent {}
